import React, { useRef, useEffect, useState } from "react";
import { X, Upload, Download } from "lucide-react";
import Dropdown from "../ui/Dropdown";

export function FieldOptionsDrawer({ field, onUpdate, onClose, isOpen }) {
  if (!field) return null;

  const lastOptionRef = useRef(null);
  const [isCSVUploaded, setIsCSVUploaded] = useState(field?.is_csv || false);

  useEffect(() => {
    console.log("Field is_csv:", field?.is_csv);
    if (field?.is_csv !== undefined) {
      setIsCSVUploaded(field.is_csv);
    }
  }, [field?.is_csv, isOpen]);

  const defaultConditions = [{ label: "", placeholder: "", trigger_value: "" }];

  const handleAddOption = () => {
    const newOptions = [...(field.options || []), ""];
    onUpdate({
      options: newOptions,
      is_csv: newOptions.length > 0 ? isCSVUploaded : false,
    });
    console.log("New option handler", newOptions);
    // Scroll after state update
    setTimeout(() => {
      if (lastOptionRef.current) {
        lastOptionRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const filteredOptions = (field.options || []).filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const renderFieldOptions = () => {
    switch (field.type) {
      case "text":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>

              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel   "
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Placeholder
              </label>
              <input
                type="text"
                value={field.placeholder || ""}
                onChange={(e) => onUpdate({ placeholder: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter placeholder text"
              />
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Max Text length
              </label>
              <input
                type="number"
                value={field.max_length || ""}
                onChange={(e) => {
                  const value = Math.max(0, Number(e.target.value));
                  onUpdate({ max_length: value });
                }}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter Max length "
              />
            </div>
          </div>
        );

      case "wysiwyg":
      case "textarea":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel   "
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Placeholder
              </label>
              <input
                type="text"
                value={field.placeholder || ""}
                onChange={(e) => onUpdate({ placeholder: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter placeholder text"
              />
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Max length
              </label>
              <input
                type="number"
                value={field.max_length || ""}
                onChange={(e) => {
                  const value = Math.max(0, Number(e.target.value));
                  onUpdate({ max_length: value });
                }}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter Text Area Max length "
              />
            </div>
          </div>
        );

      case "_wysiwyg":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel "
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Placeholder
              </label>
              <input
                type="text"
                value={field.placeholder || ""}
                onChange={(e) => onUpdate({ placeholder: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter placeholder text"
              />
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      case "phone":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel   "
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Placeholder
              </label>
              <input
                type="text"
                value={field.placeholder || ""}
                onChange={(e) => onUpdate({ placeholder: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter placeholder text"
              />
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      case "select":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel"
              />
            </div>
            <div>
              {/* <h1>isUpdate {isCSVUploaded}</h1> */}

              <div className="flex justify-between items-center">
                <label className="block text-sm font-medium text-foreground mb-1">
                  Options
                </label>

                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-1/2 px-2 py-1 mb-2 border border-input rounded-md"
                  placeholder="Search options..."
                />
                {field.options?.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      onUpdate({
                        options: [],
                        is_csv: false,
                      });
                      setSearchTerm("");
                      setIsCSVUploaded(false);
                    }}
                    className="text-sm text-red-600 hover:text-red-500"
                  >
                    Clear All
                  </button>
                )}
              </div>

              <div className="space-y-2 max-h-[calc(100vh-400px)] overflow-y-auto">
                {filteredOptions.map((option, index) => (
                  <div key={index} className="flex gap-2">
                    <input
                      type="text"
                      value={option || ""}
                      onChange={(e) => {
                        const newOptions = [...(field.options || [])];
                        const originalIndex = field.options.indexOf(option);
                        newOptions[originalIndex] = e.target.value;
                        onUpdate({
                          options: newOptions,
                          is_csv: newOptions.length > 0 ? isCSVUploaded : false,
                        });
                      }}
                      className="flex-1 px-3 py-2 border border-input rounded-md"
                      placeholder="Option label"
                      ref={
                        index === field.options?.length - 1
                          ? lastOptionRef
                          : null
                      }
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newOptions = field.options.filter(
                          (_, i) => i !== field.options.indexOf(option),
                        );
                        onUpdate({
                          options: newOptions,
                          is_csv: newOptions.length > 0 ? isCSVUploaded : false,
                        });
                      }}
                      className="p-2 text-red-500 hover:bg-red-50 rounded-md"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
                {filteredOptions.length === 0 && searchTerm && (
                  <p className="text-muted-foreground text-sm text-center">
                    No results found
                  </p>
                )}
              </div>

              <div className="mt-2 space-y-2">
                <button
                  type="button"
                  onClick={handleAddOption}
                  className="w-full px-3 py-2 text-sm text-blue-600 border border-dashed border-blue-300 rounded-md hover:bg-blue-50"
                >
                  Add Option
                </button>
                <label className="relative cursor-pointer bg-card rounded-md text-xs border-dashed text-blue-600 hover:text-blue-500 flex items-center gap-1 px-2 py-1">
                  {field.is_csv && field.options?.length > 0 ? (
                    <div className="flex items-center gap-2 w-full">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          const csvContent =
                            "data:text/csv;charset=utf-8," +
                            "Option\n" +
                            field.options.join("\n");
                          const encodedUri = encodeURI(csvContent);
                          const link = document.createElement("a");
                          link.setAttribute("href", encodedUri);
                          link.setAttribute("download", "options.csv");
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        className="flex items-center gap-1 text-blue-600 hover:text-blue-500"
                      >
                        <Download className="w-3 h-3" />
                        <span>Download CSV</span>
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          onUpdate({
                            options: [],
                            is_csv: false,
                          });
                          setIsCSVUploaded(false);
                        }}
                        className="text-red-600 hover:text-red-500 flex items-center gap-1 ml-auto"
                      >
                        <X className="w-3 h-3" />
                        <span>Remove CSV</span>
                      </button>
                    </div>
                  ) : (
                    <>
                      <Upload className="w-3 h-3" />
                      <span>Upload CSV</span>
                    </>
                  )}
                  <input
                    type="file"
                    className="sr-only"
                    accept=".csv"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                          const csvData = event.target.result;
                          const options = csvData
                            .split("\n")
                            .map((line) => line.trim())
                            .filter((line) => line);
                          onUpdate({
                            options: [...options],
                            is_csv: true,
                            isCSVUploaded: true,
                          });
                          setIsCSVUploaded(true);
                          // Clear the input after processing
                          e.target.value = null;
                        };
                        reader.readAsText(file);
                      }
                    }}
                  />
                </label>
              </div>
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      // fix this issue on radio: when drawer close the has required field become unchecked why?
      case "radio":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-muted-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) => onUpdate({ sublabel: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Options
              </label>
              <div className="space-y-2">
                {(field.options || []).map((option, index) => (
                  <div key={index} className="flex gap-2">
                    <input
                      type="text"
                      value={option || ""}
                      onChange={(e) => {
                        const newOptions = [...(field.options || [])];
                        if (e.target.value.includes(",")) {
                          e.target.value = e.target.value.replace(/,/g, "");
                        }
                        newOptions[index] = e.target.value;
                        onUpdate({
                          options: newOptions,
                          is_csv: newOptions.length > 0 ? isCSVUploaded : false,
                        });
                      }}
                      className="flex-1 px-3 py-2 border border-input rounded-md"
                      placeholder="Option label"
                      title="Commas are not allowed in this field"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newOptions = field.options.filter(
                          (_, i) => i !== index,
                        );
                        onUpdate({
                          options: newOptions,
                          is_csv: newOptions.length > 0 ? isCSVUploaded : false,
                        });
                      }}
                      className="p-2 text-red-500 hover:bg-red-50 rounded-md"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => {
                    const newOptions = [...(field.options || []), ""];
                    console.log("newOptions", { options: newOptions });
                    onUpdate({
                      options: newOptions,
                      is_csv: newOptions.length > 0 ? isCSVUploaded : false,
                    });
                  }}
                  className="w-full px-3 py-2 text-sm text-blue-600 border border-dashed border-blue-300 rounded-md hover:bg-blue-50"
                >
                  Add Option
                </button>
              </div>
            </div>

            {/* CSV Upload Section for Radio */}
            <div className="mt-2 space-y-2">
              <label className="relative cursor-pointer bg-card rounded-md text-xs border-dashed text-blue-600 hover:text-blue-500 flex items-center gap-1 px-2 py-1">
                {field.is_csv && field.options?.length > 0 ? (
                  <div className="flex items-center gap-2 w-full">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        const csvContent =
                          "data:text/csv;charset=utf-8," +
                          "Option\n" +
                          field.options.join("\n");
                        const encodedUri = encodeURI(csvContent);
                        const link = document.createElement("a");
                        link.setAttribute("href", encodedUri);
                        link.setAttribute("download", "options.csv");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                      className="flex items-center gap-1 text-blue-600 hover:text-blue-500"
                    >
                      <Download className="w-3 h-3" />
                      <span>Download CSV</span>
                    </button>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        onUpdate({
                          options: [],
                          is_csv: false,
                        });
                        setIsCSVUploaded(false);
                      }}
                      className="text-red-600 hover:text-red-500 flex items-center gap-1 ml-auto"
                    >
                      <X className="w-3 h-3" />
                      <span>Remove CSV</span>
                    </button>
                  </div>
                ) : (
                  <>
                    <Upload className="w-3 h-3" />
                    <span>Upload CSV</span>
                  </>
                )}
                <input
                  type="file"
                  className="sr-only"
                  accept=".csv"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = (event) => {
                        const csvData = event.target.result;
                        const options = csvData
                          .split("\n")
                          .map((line) => line.trim())
                          .filter((line) => line);
                        onUpdate({
                          options: [...options],
                          is_csv: true,
                          isCSVUploaded: true,
                        });
                        setIsCSVUploaded(true);
                        // Clear the input after processing
                        e.target.value = null;
                      };
                      reader.readAsText(file);
                    }
                  }}
                />
              </label>
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="toggle"
                checked={field.has_condition || false}
                onChange={(e) => {
                  onUpdate({
                    has_condition: e.target.checked,
                    conditions: e.target.checked
                      ? field?.conditions?.length
                        ? field.conditions
                        : [...defaultConditions]
                      : null,
                  });
                }}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="toggle"
                className="text-sm font-medium text-foreground"
              >
                Has Condition
              </label>
            </div>
            {field.has_condition && (
              <>
                <h3>Conditional Field</h3>
                {field.conditions?.map((condition, index) => {
                  return (
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-foreground mb-1">
                          Input Label
                        </label>
                        <input
                          type="text"
                          value={condition.label || ""}
                          onChange={(e) =>
                            onUpdate({
                              conditions: field.conditions.map((c, i) =>
                                i === index
                                  ? { ...c, label: e.target.value }
                                  : c,
                              ),
                            })
                          }
                          className="w-full px-3 py-2 border border-input rounded-md"
                          placeholder="Enter condition label"
                          required={true}
                        />
                        {!condition.label && (
                          <p className="text-red-500 text-xs mt-0.5">
                            This field is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-foreground mb-1">
                          Input Placeholder
                        </label>
                        <input
                          type="text"
                          value={condition.placeholder || ""}
                          onChange={(e) =>
                            onUpdate({
                              conditions: field.conditions.map((c, i) =>
                                i === index
                                  ? { ...c, placeholder: e.target.value }
                                  : c,
                              ),
                            })
                          }
                          className="w-full px-3 py-2 border border-input rounded-md"
                          placeholder="Enter condition placeholder"
                          required={true}
                        />
                        {!condition.placeholder && (
                          <p className="text-red-500 text-xs mt-0.5">
                            This field is required
                          </p>
                        )}
                      </div>
                      <div className="flex items-center flex-col mb-1">
                        <div className="flex items-center w-full justify-between">
                          <label className="block text-sm font-medium text-foreground">
                            Trigger Value
                          </label>
                          {condition.trigger_value && (
                            <button
                              type="button"
                              onClick={() =>
                                onUpdate({
                                  conditions: field.conditions.map((c, i) =>
                                    i === index
                                      ? { ...c, trigger_value: "" }
                                      : c,
                                  ),
                                })
                              }
                              className="p-1 text-red-500 hover:text-red-700 rounded-md text-xs"
                            >
                              Reset
                            </button>
                          )}
                        </div>
                        <div className="flex w-full gap-2">
                          <Dropdown
                            options={[...(field.options || [])]}
                            value={condition.trigger_value || ""}
                            onChange={(selectedOption) =>
                              onUpdate({
                                conditions: field.conditions.map((c, i) =>
                                  i === index
                                    ? { ...c, trigger_value: selectedOption }
                                    : c,
                                ),
                              })
                            }
                            searchable={true}
                            placeholder="Select trigger value"
                            className="flex-1"
                          />
                        </div>
                        {!condition.trigger_value && (
                          <p className="text-red-500 text-xs mt-0.5 w-full">
                            This field is required
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        );

      case "checkbox":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) => onUpdate({ sublabel: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Options
              </label>
              <div className="space-y-2">
                {(field.options || []).map((option, index) => (
                  <div key={index} className="flex gap-2">
                    <input
                      type="text"
                      value={option || ""}
                      onChange={(e) => {
                        const newOptions = [...(field.options || [])];
                        newOptions[index] = e.target.value;
                        onUpdate({
                          options: newOptions,
                          is_csv: newOptions.length > 0 ? isCSVUploaded : false,
                        });
                      }}
                      className="flex-1 px-3 py-2 border border-input rounded-md"
                      placeholder="Option label"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newOptions = field.options.filter(
                          (_, i) => i !== index,
                        );
                        onUpdate({
                          options: newOptions,
                          is_csv: newOptions.length > 0 ? isCSVUploaded : false,
                        });
                      }}
                      className="p-2 text-red-500 hover:bg-red-50 rounded-md"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => {
                    const newOptions = [...(field.options || []), ""];
                    onUpdate({
                      options: newOptions,
                      is_csv: newOptions.length > 0 ? isCSVUploaded : false,
                    });
                  }}
                  className="w-full px-3 py-2 text-sm text-blue-600 border border-dashed border-blue-300 rounded-md hover:bg-blue-50"
                >
                  Add Option
                </button>
              </div>
            </div>

            {/* CSV Upload Section for Checkbox */}
            <div className="mt-2 space-y-2">
              <label className="relative cursor-pointer bg-card rounded-md text-xs border-dashed text-blue-600 hover:text-blue-500 flex items-center gap-1 px-2 py-1">
                {field.is_csv && field.options?.length > 0 ? (
                  <div className="flex items-center gap-2 w-full">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        const csvContent =
                          "data:text/csv;charset=utf-8," +
                          "Option\n" +
                          field.options.join("\n");
                        const encodedUri = encodeURI(csvContent);
                        const link = document.createElement("a");
                        link.setAttribute("href", encodedUri);
                        link.setAttribute("download", "options.csv");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                      className="flex items-center gap-1 text-blue-600 hover:text-blue-500"
                    >
                      <Download className="w-3 h-3" />
                      <span>Download CSV</span>
                    </button>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        onUpdate({
                          options: [],
                          is_csv: false,
                        });
                        setIsCSVUploaded(false);
                      }}
                      className="text-red-600 hover:text-red-500 flex items-center gap-1 ml-auto"
                    >
                      <X className="w-3 h-3" />
                      <span>Remove CSV</span>
                    </button>
                  </div>
                ) : (
                  <>
                    <Upload className="w-3 h-3" />
                    <span>Upload CSV</span>
                  </>
                )}
                <input
                  type="file"
                  className="sr-only"
                  accept=".csv"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = (event) => {
                        const csvData = event.target.result;
                        const options = csvData
                          .split("\n")
                          .map((line) => line.trim())
                          .filter((line) => line);
                        onUpdate({
                          options: [...options],
                          is_csv: true,
                          isCSVUploaded: true,
                        });
                        setIsCSVUploaded(true);
                        // Clear the input after processing
                        e.target.value = null;
                      };
                      reader.readAsText(file);
                    }
                  }}
                />
              </label>
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="toggle"
                checked={field.has_condition || false}
                onChange={(e) => {
                  onUpdate({
                    has_condition: e.target.checked,
                    conditions: e.target.checked
                      ? field?.conditions?.length
                        ? field.conditions
                        : [...defaultConditions]
                      : null,
                  });
                }}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="toggle"
                className="text-sm font-medium text-foreground"
              >
                Has Condition
              </label>
            </div>
            {field.has_condition && (
              <>
                <h3>Conditional Field</h3>
                {field.conditions?.map((condition, index) => {
                  return (
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-foreground mb-1">
                          Input Label
                        </label>
                        <input
                          type="text"
                          value={condition.label || ""}
                          onChange={(e) =>
                            onUpdate({
                              conditions: field.conditions.map((c, i) =>
                                i === index
                                  ? { ...c, label: e.target.value }
                                  : c,
                              ),
                            })
                          }
                          className="w-full px-3 py-2 border border-input rounded-md"
                          placeholder="Enter condition label"
                          required={true}
                        />
                        {!condition.label && (
                          <p className="text-red-500 text-xs mt-0.5">
                            This field is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-foreground mb-1">
                          Input Placeholder
                        </label>
                        <input
                          type="text"
                          value={condition.placeholder || ""}
                          onChange={(e) =>
                            onUpdate({
                              conditions: field.conditions.map((c, i) =>
                                i === index
                                  ? { ...c, placeholder: e.target.value }
                                  : c,
                              ),
                            })
                          }
                          className="w-full px-3 py-2 border border-input rounded-md"
                          placeholder="Enter condition placeholder"
                          required={true}
                        />
                        {!condition.placeholder && (
                          <p className="text-red-500 text-xs mt-0.5">
                            This field is required
                          </p>
                        )}
                      </div>
                      <div className="flex items-center flex-col mb-1">
                        <div className="flex items-center w-full justify-between">
                          <label className="block text-sm font-medium text-foreground">
                            Trigger Value
                          </label>
                          {condition.trigger_value && (
                            <button
                              type="button"
                              onClick={() =>
                                onUpdate({
                                  conditions: field.conditions.map((c, i) =>
                                    i === index
                                      ? { ...c, trigger_value: "" }
                                      : c,
                                  ),
                                })
                              }
                              className="p-1 text-red-500 hover:text-red-700 rounded-md text-xs"
                            >
                              Reset
                            </button>
                          )}
                        </div>
                        <div className="flex w-full gap-2">
                          <Dropdown
                            options={[...(field.options || [])]}
                            value={condition.trigger_value || ""}
                            onChange={(selectedOption) =>
                              onUpdate({
                                conditions: field.conditions.map((c, i) =>
                                  i === index
                                    ? { ...c, trigger_value: selectedOption }
                                    : c,
                                ),
                              })
                            }
                            searchable={true}
                            placeholder="Select trigger value"
                            className="flex-1"
                          />
                        </div>
                        {!condition.trigger_value && (
                          <p className="text-red-500 text-xs mt-0.5 w-full">
                            This field is required
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        );

      case "file":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel   "
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Upload File
              </label>
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-input border-dashed rounded-md hover:border-blue-500 transition-colors">
                <div className="space-y-1 text-center">
                  <Upload className="mx-auto h-12 w-12 text-muted-foreground" />
                  <div className="flex text-sm text-muted-foreground">
                    <label className="relative cursor-pointer bg-card rounded-md font-medium text-blue-600 hover:text-blue-500">
                      <span>Choose a file</span>
                      <input
                        type="file"
                        className="sr-only"
                        accept="*/*"
                        onChange={(e) => {
                          // Optionally update file value in your state:
                          // e.g., onUpdate({ file: e.target.files[0] });
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      case "image":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Image
              </label>
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-input border-dashed rounded-md hover:border-blue-500 transition-colors">
                <div className="space-y-1 text-center">
                  <Upload className="mx-auto h-12 w-12 text-muted-foreground" />
                  <div className="flex text-sm text-muted-foreground">
                    <label className="relative cursor-pointer bg-card rounded-md font-medium text-blue-600 hover:text-blue-500">
                      <span>Choose a file</span>
                      <input type="file" className="sr-only" accept="image/*" />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel   "
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Size
              </label>
              <input
                type="number"
                value={field.size || ""}
                onChange={(e) => onUpdate({ size: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter size in pixels"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Image Alignment
              </label>
              <div className="flex gap-2">
                {["left", "center", "right"].map((align) => (
                  <button
                    type="button"
                    key={align}
                    onClick={() => onUpdate({ alignment: align })}
                    className={`flex-1 px-3 py-2 border rounded-md capitalize ${
                      field.alignment === align
                        ? "bg-blue-50 border-blue-500 text-blue-600"
                        : "border-input hover:bg-muted"
                    }`}
                  >
                    {align}
                  </button>
                ))}
              </div>
            </div>
          </div>
        );

      case "heading":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Heading Text
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter heading text"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Subheading Text
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) => onUpdate({ sublabel: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter subheading text"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Heading Size
              </label>
              <select
                value={field.headingSize || "large"}
                onChange={(e) => onUpdate({ headingSize: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
              >
                <option value="large">Large</option>
                <option value="default">Default</option>
                <option value="small">Small</option>
              </select>
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      case "email":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel   "
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Placeholder
              </label>
              <input
                type="text"
                value={field.placeholder || ""}
                onChange={(e) => onUpdate({ placeholder: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter placeholder text"
              />
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      case "number":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel   "
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Placeholder
              </label>
              <input
                type="text"
                value={field.placeholder || ""}
                onChange={(e) => onUpdate({ placeholder: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter placeholder text"
              />
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      case "date":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Placeholder
              </label>
              <input
                type="text"
                value={field.placeholder || ""}
                onChange={(e) => onUpdate({ placeholder: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter placeholder text"
              />
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      case "university_repeatable":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Field Label
              </label>
              <input
                type="text"
                value={field.label || ""}
                onChange={(e) => onUpdate({ label: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field label"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Sublabel
              </label>
              <input
                type="text"
                value={field.sublabel || ""}
                onChange={(e) =>
                  onUpdate({
                    sublabel:
                      e.target.value.trim() === "" ? null : e.target.value,
                  })
                }
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter sublabel"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Placeholder
              </label>
              <input
                type="text"
                value={field.placeholder || ""}
                onChange={(e) => onUpdate({ placeholder: e.target.value })}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter placeholder text"
              />
            </div>

            <hr className="border-border" />

            {/* Other Field Labels */}
            <div>
              <label className="block text-sm font-medium text-muted-foreground mb-1">
                Field of Study Label:
              </label>
              <input
                type="text"
                value={field.fieldLabels?.fieldOfStudyLabel || ""}
                onChange={(e) => {
                  const newFieldLabels = { ...field.fieldLabels };
                  if (e.target.value.trim() === "") {
                    delete newFieldLabels.fieldOfStudyLabel;
                  } else {
                    newFieldLabels.fieldOfStudyLabel = e.target.value;
                  }
                  onUpdate({ fieldLabels: newFieldLabels });
                }}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter field of study label"
              />
            </div>

            <hr className="border-border" />
            <div>
              <label className="block text-sm font-medium text-muted-foreground mb-1">
                Graduation Year Label:
              </label>
              <input
                type="text"
                value={field.fieldLabels?.graduationYearLabel || ""}
                onChange={(e) => {
                  const newFieldLabels = { ...field.fieldLabels };
                  if (e.target.value.trim() === "") {
                    delete newFieldLabels.graduationYearLabel;
                  } else {
                    newFieldLabels.graduationYearLabel = e.target.value;
                  }
                  onUpdate({ fieldLabels: newFieldLabels });
                }}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter graduation year label"
              />
            </div>

            <hr className="border-border" />
            <div>
              <label className="block text-sm font-medium text-muted-foreground mb-1">
                GPA Label:
              </label>
              <input
                type="text"
                value={field.fieldLabels?.gpaLabel || ""}
                onChange={(e) => {
                  const newFieldLabels = { ...field.fieldLabels };
                  if (e.target.value.trim() === "") {
                    delete newFieldLabels.gpaLabel;
                  } else {
                    newFieldLabels.gpaLabel = e.target.value;
                  }
                  onUpdate({ fieldLabels: newFieldLabels });
                }}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter GPA label"
              />
            </div>

            <hr className="border-border" />
            {/* University Field and Options */}
            <div>
              <label className="block text-sm font-medium text-muted-foreground mb-1">
                University Field Label:
              </label>
              <input
                type="text"
                value={field.fieldLabels?.universityLabel || ""}
                onChange={(e) => {
                  const newFieldLabels = { ...field.fieldLabels };
                  if (e.target.value.trim() === "") {
                    delete newFieldLabels.universityLabel;
                  } else {
                    newFieldLabels.universityLabel = e.target.value;
                  }
                  onUpdate({ fieldLabels: newFieldLabels });
                }}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter university field label"
              />
            </div>

            {/* University Options */}
            <div>
              <div className="flex justify-between items-center">
                <label className="block text-sm font-medium text-foreground mb-1">
                  University Options
                </label>
                {field.universityOptions?.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      onUpdate({
                        universityOptions: [],
                        is_university_csv: false,
                      });
                    }}
                    className="text-sm text-red-600 hover:text-red-500"
                  >
                    Clear All
                  </button>
                )}
              </div>

              <div className="space-y-2 max-h-[200px] overflow-y-auto">
                {(field.universityOptions || []).map((option, index) => (
                  <div key={index} className="flex gap-2">
                    <input
                      type="text"
                      value={option || ""}
                      onChange={(e) => {
                        const newOptions = [...(field.universityOptions || [])];
                        newOptions[index] = e.target.value;
                        onUpdate({ universityOptions: newOptions });
                      }}
                      className="flex-1 px-3 py-2 border border-input rounded-md"
                      placeholder="University name"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newOptions = field.universityOptions.filter(
                          (_, i) => i !== index,
                        );
                        onUpdate({
                          universityOptions: newOptions,
                          is_university_csv:
                            newOptions.length > 0
                              ? field.is_university_csv
                              : false,
                        });
                      }}
                      className="p-2 text-red-500 hover:bg-red-50 rounded-md"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>

              <div className="mt-2 space-y-2">
                <button
                  type="button"
                  onClick={() => {
                    const newOptions = [...(field.universityOptions || []), ""];
                    onUpdate({ universityOptions: newOptions });
                  }}
                  className="w-full px-3 py-2 text-sm text-blue-600 border border-dashed border-blue-300 rounded-md hover:bg-blue-50"
                >
                  Add University Option
                </button>
                <label className="relative cursor-pointer bg-card rounded-md text-xs border-dashed text-blue-600 hover:text-blue-500 flex items-center gap-1 px-2 py-1">
                  {field.is_university_csv &&
                  field.universityOptions?.length > 0 ? (
                    <div className="flex items-center gap-2 w-full">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          const csvContent =
                            "data:text/csv;charset=utf-8," +
                            "University\n" +
                            field.universityOptions.join("\n");
                          const encodedUri = encodeURI(csvContent);
                          const link = document.createElement("a");
                          link.setAttribute("href", encodedUri);
                          link.setAttribute(
                            "download",
                            "university_options.csv",
                          );
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        className="flex items-center gap-1 text-blue-600 hover:text-blue-500"
                      >
                        <Download className="w-3 h-3" />
                        <span>Download CSV</span>
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          onUpdate({
                            universityOptions: [],
                            is_university_csv: false,
                          });
                        }}
                        className="text-red-600 hover:text-red-500 flex items-center gap-1 ml-auto"
                      >
                        <X className="w-3 h-3" />
                        <span>Remove CSV</span>
                      </button>
                    </div>
                  ) : (
                    <>
                      <Upload className="w-3 h-3" />
                      <span>Upload CSV</span>
                    </>
                  )}
                  <input
                    type="file"
                    className="sr-only"
                    accept=".csv"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                          const csvData = event.target.result;
                          const options = csvData
                            .split("\n")
                            // .slice(1)
                            .map((line) => line.trim())
                            .filter((line) => line);
                          onUpdate({
                            universityOptions: [...options],
                            is_university_csv: true,
                          });
                          // Clear the input after processing
                          e.target.value = null;
                        };
                        reader.readAsText(file);
                      }
                    }}
                  />
                </label>
              </div>
            </div>

            <hr className="border-border" />

            {/* Degree Field and Options */}
            <div>
              <label className="block text-sm font-medium text-muted-foreground mb-1">
                Degree Field Label:
              </label>
              <input
                type="text"
                value={field.fieldLabels?.degreeLabel || ""}
                onChange={(e) => {
                  const newFieldLabels = { ...field.fieldLabels };
                  if (e.target.value.trim() === "") {
                    delete newFieldLabels.degreeLabel;
                  } else {
                    newFieldLabels.degreeLabel = e.target.value;
                  }
                  onUpdate({ fieldLabels: newFieldLabels });
                }}
                className="w-full px-3 py-2 border border-input rounded-md"
                placeholder="Enter degree field label"
              />
            </div>

            {/* Degree Options */}
            <div>
              <div className="flex justify-between items-center">
                <label className="block text-sm font-medium text-foreground mb-1">
                  Degree Options
                </label>
                {field.degreeOptions?.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      onUpdate({
                        degreeOptions: [],
                        is_degree_csv: false,
                      });
                    }}
                    className="text-sm text-red-600 hover:text-red-500"
                  >
                    Clear All
                  </button>
                )}
              </div>

              <div className="space-y-2 max-h-[200px] overflow-y-auto">
                {(field.degreeOptions || []).map((option, index) => (
                  <div key={index} className="flex gap-2">
                    <input
                      type="text"
                      value={option || ""}
                      onChange={(e) => {
                        const newOptions = [...(field.degreeOptions || [])];
                        newOptions[index] = e.target.value;
                        onUpdate({ degreeOptions: newOptions });
                      }}
                      className="flex-1 px-3 py-2 border border-input rounded-md"
                      placeholder="Degree/qualification name"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newOptions = field.degreeOptions.filter(
                          (_, i) => i !== index,
                        );
                        onUpdate({
                          degreeOptions: newOptions,
                          is_degree_csv:
                            newOptions.length > 0 ? field.is_degree_csv : false,
                        });
                      }}
                      className="p-2 text-red-500 hover:bg-red-50 rounded-md"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>

              <div className="mt-2 space-y-2">
                <button
                  type="button"
                  onClick={() => {
                    const newOptions = [...(field.degreeOptions || []), ""];
                    onUpdate({ degreeOptions: newOptions });
                  }}
                  className="w-full px-3 py-2 text-sm text-blue-600 border border-dashed border-blue-300 rounded-md hover:bg-blue-50"
                >
                  Add Degree Option
                </button>
                <label className="relative cursor-pointer bg-card rounded-md text-xs border-dashed text-blue-600 hover:text-blue-500 flex items-center gap-1 px-2 py-1">
                  {field.is_degree_csv && field.degreeOptions?.length > 0 ? (
                    <div className="flex items-center gap-2 w-full">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          const csvContent =
                            "data:text/csv;charset=utf-8," +
                            "Degree\n" +
                            field.degreeOptions.join("\n");
                          const encodedUri = encodeURI(csvContent);
                          const link = document.createElement("a");
                          link.setAttribute("href", encodedUri);
                          link.setAttribute("download", "degree_options.csv");
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        className="flex items-center gap-1 text-blue-600 hover:text-blue-500"
                      >
                        <Download className="w-3 h-3" />
                        <span>Download CSV</span>
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          onUpdate({
                            degreeOptions: [],
                            is_degree_csv: false,
                          });
                        }}
                        className="text-red-600 hover:text-red-500 flex items-center gap-1 ml-auto"
                      >
                        <X className="w-3 h-3" />
                        <span>Remove CSV</span>
                      </button>
                    </div>
                  ) : (
                    <>
                      <Upload className="w-3 h-3" />
                      <span>Upload CSV</span>
                    </>
                  )}
                  <input
                    type="file"
                    className="sr-only"
                    accept=".csv"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                          const csvData = event.target.result;
                          const options = csvData
                            .split("\n")
                            .map((line) => line.trim())
                            .filter((line) => line);
                          onUpdate({
                            degreeOptions: [...options],
                            is_degree_csv: true,
                          });
                          // Clear the input after processing
                          e.target.value = null;
                        };
                        reader.readAsText(file);
                      }
                    }}
                  />
                </label>
              </div>
            </div>

            <hr className="border-border" />

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="required"
                checked={field.is_required || false}
                onChange={(e) => onUpdate({ is_required: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-input"
              />
              <label
                htmlFor="required"
                className="text-sm font-medium text-foreground"
              >
                Required field
              </label>
            </div>
          </div>
        );

      // case  'spacer':
      //   return (
      //     <div className="space-y-4">
      //       <div>

      //         <label className="block text-sm font-medium text-foreground mb-1">
      //           Field label
      //         </label>

      //       </div>
      //     </div>
      //   );

      // Add more cases for other field types if needed...
      default:
        return null;
    }
  };

  return (
    <div
      className={`fixed inset-y-0 right-0 w-80 bg-card shadow-lg transform transition-transform duration-200 z-[90] ${
        isOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="h-full flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-brand/20">
          <h3 className="text-lg font-semibold text-foreground">Field Properties</h3>
          <button
            type="button"
            onClick={onClose}
            className="p-1 hover:bg-muted rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-foreground" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">{renderFieldOptions()}</div>
      </div>
    </div>
  );
}
